module.exports = __webpack_public_path__ + "img/grey-intensives-1.de0c315c.png";